module.exports = __webpack_public_path__ + "img/USERS_SETTING.8f3616bb.svg";